export const rawSigtap = [
  {
    nm: null,
    nome: 'MEDIÇÃO DE ALTURA',
    codigo: '0101040075',
    id_grupo: 'ALTURA',
  },
  {
    nm: null,
    nome: 'AVALIAÇÃO ANTROPOMÉTRICA',
    codigo: '0101040024',
    id_grupo: 'ANTROP',
  },
  {
    nm: null,
    nome: 'DOSAGEM DE HEMOGLOBINA GLICOSILADA',
    codigo: '0202010503',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'EXAME DO PÉ DIABÉTICO',
    codigo: '0301040095',
    id_grupo: 'DIABETES',
  },
  {
    nm: 1,
    nome: 'EXODONTIA DE DENTE PERMANENTE',
    codigo: '0414020138',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 1,
    nome: 'EXODONTIA MÚLTIPLA COM ALVEOLOPLASTIA POR SEXTANTE',
    codigo: '0414020146',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'APLICAÇÃO DE CARIOSTÁTICO (POR DENTE)',
    codigo: '0101020058',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'APLICAÇÃO DE SELANTE (POR DENTE)',
    codigo: '0101020066',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'APLICAÇÃO TÓPICA DE FLÚOR (INDIVIDUAL POR SESSÃO)',
    codigo: '0101020074',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'EVIDENCIAÇÃO DE PLACA BACTERIANA',
    codigo: '0101020082',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'SELAMENTO PROVISÓRIO DE CAVIDADE DENTÁRIA',
    codigo: '0101020090',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'ORIENTAÇÃO DE HIGIENIZAÇÃO DE PRÓTESES DENTÁRIAS',
    codigo: '0101020120',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'CAPEAMENTO PULPAR',
    codigo: '0307010015',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE PERMANENTE ANTERIOR COM RESINA COMPOSTA',
    codigo: '0307010031',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'TRATAMENTO INICIAL DO DENTE TRAUMATIZADO',
    codigo: '0307010066',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'TRATAMENTO RESTAURADOR ATRAUMÁTICO (TRA/ART)',
    codigo: '0307010074',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE DECÍDUO POSTERIOR COM RESINA COMPOSTA',
    codigo: '0307010082',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE DECÍDUO POSTERIOR COM IONÔMERO DE VIDRO',
    codigo: '0307010104',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE DECÍDUO ANTERIOR COM RESINA COMPOSTA.',
    codigo: '0307010112',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE PERMANENTE POSTERIOR COM RESINA COMPOSTA',
    codigo: '0307010120',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'ACESSO A POLPA DENTARIA E MEDICACAO (POR DENTE)',
    codigo: '0307020010',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'CURATIVO DE DEMORA C/ OU S/ PREPARO BIOMECANICO',
    codigo: '0307020029',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'PULPOTOMIA DENTÁRIA',
    codigo: '0307020070',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'RASPAGEM ALISAMENTO SUBGENGIVAIS (POR SEXTANTE)',
    codigo: '0307030024',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'PROFILAXIA / REMOÇÃO DA PLACA BACTERIANA',
    codigo: '0307030040',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'RASPAGEM ALISAMENTO E POLIMENTO SUPRAGENGIVAIS (POR SEXTANTE)',
    codigo: '0307030059',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'TRATAMENTO DE GENGIVITE ULCERATIVA NECROSANTE AGUDA (GUNA)',
    codigo: '0307030067',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'TRATAMENTO DE LESÕES DA MUCOSA ORAL',
    codigo: '0307030075',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'TRATAMENTO DE PERICORONARITE',
    codigo: '0307030083',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 0,
    nome: 'FOTOBIOMODULAÇÃO A LASER DE BAIXA POTÊNCIA PARA O TRATAMENTO DA MUCOSITE ORAL RADIOINDUZIDA E/OU QUIMIOINDUZIDA',
    codigo: '0307050017',
    id_grupo: 'DN_EXODONTIA',
  },
  {
    nm: 1,
    nome: 'APLICAÇÃO DE CARIOSTÁTICO (POR DENTE)',
    codigo: '0101020058',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 1,
    nome: 'APLICAÇÃO DE SELANTE (POR DENTE)',
    codigo: '0101020066',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 1,
    nome: 'APLICAÇÃO TÓPICA DE FLÚOR (INDIVIDUAL POR SESSÃO)',
    codigo: '0101020074',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 1,
    nome: 'EVIDENCIAÇÃO DE PLACA BACTERIANA',
    codigo: '0101020082',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 1,
    nome: 'ORIENTAÇÃO DE HIGIENE BUCAL',
    codigo: '0101020104',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 1,
    nome: 'ORIENTAÇÃO DE HIGIENIZAÇÃO DE PRÓTESES DENTÁRIAS',
    codigo: '0101020120',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 1,
    nome: 'PROFILAXIA / REMOÇÃO DA PLACA BACTERIANA',
    codigo: '0307030040',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'SELAMENTO PROVISÓRIO DE CAVIDADE DENTÁRIA',
    codigo: '0101020090',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'CAPEAMENTO PULPAR',
    codigo: '0307010015',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE PERMANENTE ANTERIOR COM RESINA COMPOSTA',
    codigo: '0307010031',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'TRATAMENTO INICIAL DO DENTE TRAUMATIZADO',
    codigo: '0307010066',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'TRATAMENTO RESTAURADOR ATRAUMÁTICO (TRA/ART)',
    codigo: '0307010074',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE DECÍDUO POSTERIOR COM RESINA COMPOSTA',
    codigo: '0307010082',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE DECÍDUO POSTERIOR COM IONÔMERO DE VIDRO',
    codigo: '0307010104',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE DECÍDUO ANTERIOR COM RESINA COMPOSTA.',
    codigo: '0307010112',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE PERMANENTE POSTERIOR COM RESINA COMPOSTA',
    codigo: '0307010120',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'ADEQUAÇÃO DO COMPORTAMENTO DA PESSOA COM DEFICIÊNCIA',
    codigo: '0307010147',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'ADEQUAÇÃO DO COMPORTAMENTO DE CRIANÇAS',
    codigo: '0307010155',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'ACESSO A POLPA DENTARIA E MEDICACAO (POR DENTE)',
    codigo: '0307020010',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'CURATIVO DE DEMORA C/ OU S/ PREPARO BIOMECANICO',
    codigo: '0307020029',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'PULPOTOMIA DENTÁRIA',
    codigo: '0307020070',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'RASPAGEM ALISAMENTO SUBGENGIVAIS (POR SEXTANTE)',
    codigo: '0307030024',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'RASPAGEM ALISAMENTO E POLIMENTO SUPRAGENGIVAIS (POR SEXTANTE)',
    codigo: '0307030059',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'TRATAMENTO DE GENGIVITE ULCERATIVA NECROSANTE AGUDA (GUNA)',
    codigo: '0307030067',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'TRATAMENTO DE LESÕES DA MUCOSA ORAL',
    codigo: '0307030075',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'TRATAMENTO DE PERICORONARITE',
    codigo: '0307030083',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'FOTOBIOMODULAÇÃO A LASER DE BAIXA POTÊNCIA PARA O TRATAMENTO DA MUCOSITE ORAL RADIOINDUZIDA E/OU QUIMIOINDUZIDA',
    codigo: '0307050017',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 0,
    nome: 'EXODONTIA DE DENTE PERMANENTE',
    codigo: '0414020138',
    id_grupo: 'DN_PREVENTIVOS_ODONTO',
  },
  {
    nm: 1,
    nome: 'TRATAMENTO RESTAURADOR ATRAUMÁTICO (TRA/ART)',
    codigo: '0307010074',
    id_grupo: 'DN_TRA_ART',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE PERMANENTE ANTERIOR COM RESINA COMPOSTA',
    codigo: '0307010031',
    id_grupo: 'DN_TRA_ART',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE DECÍDUO POSTERIOR COM RESINA COMPOSTA',
    codigo: '0307010082',
    id_grupo: 'DN_TRA_ART',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE DECÍDUO POSTERIOR COM IONÔMERO DE VIDRO',
    codigo: '0307010104',
    id_grupo: 'DN_TRA_ART',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE DECÍDUO ANTERIOR COM RESINA COMPOSTA.',
    codigo: '0307010112',
    id_grupo: 'DN_TRA_ART',
  },
  {
    nm: 0,
    nome: 'RESTAURAÇÃO DE DENTE PERMANENTE POSTERIOR COM RESINA COMPOSTA',
    codigo: '0307010120',
    id_grupo: 'DN_TRA_ART',
  },
  {
    nm: null,
    nome: 'CONSULTA PRÉ-NATAL',
    codigo: '0301010110',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PESQUISA DE ANTICORPOS IGG E IGM CONTRA ANTIGENO CENTRAL DO VIRUS DA HEPATITE B (ANTI-HBC-TOTAL)',
    codigo: '0202030784',
    id_grupo: 'HEPATITEB',
  },
  {
    nm: null,
    nome: 'PESQUISA DE ANTIGENO DE SUPERFICIE DO VIRUS DA HEPATITE B (HBSAG)',
    codigo: '0202030970',
    id_grupo: 'HEPATITEB',
  },
  {
    nm: null,
    nome: 'IDENTIFICACAO DO VIRUS DA HEPATITE B POR PCR (QUANTITATIVO)',
    codigo: '0213010208',
    id_grupo: 'HEPATITEB',
  },
  {
    nm: null,
    nome: 'TESTE RÁPIDO PARA DETECÇÃO DE INFECÇÃO PELO HBV',
    codigo: '0214010104',
    id_grupo: 'HEPATITEB',
  },
  {
    nm: null,
    nome: 'TESTE RÁPIDO PARA DETECÇÃO DO ANTÍGENO DE SUPERFÍCIE DO VÍRUS DA HEPATITE B - HBV (HBSAG) EM GESTANTE',
    codigo: '0214010236',
    id_grupo: 'HEPATITEB',
  },
  {
    nm: null,
    nome: 'QUANTIFICACAO DA CARGA VIRAL DO HIV (RNA)',
    codigo: '0213010500',
    id_grupo: 'HIV',
  },
  {
    nm: null,
    nome: 'DETECÇÃO RÁPIDA DA CARGA VIRAL DO HIV',
    codigo: '0213010780',
    id_grupo: 'HIV',
  },
  {
    nm: null,
    nome: 'TESTE RAPIDO PARA DETECCAO DE HIV NA GESTANTE OU PAI/PARCEIRO',
    codigo: '0214010040',
    id_grupo: 'HIV',
  },
  {
    nm: null,
    nome: 'TESTE RÁPIDO PARA DETECÇÃO DE ANTICORPOS ANTI-HIV PARAPOPULAÇÃO GERAL (EXCETO GESTANTE, PARCEIRO OU PARCERIA)',
    codigo: '0214010058',
    id_grupo: 'HIV',
  },
  {
    nm: null,
    nome: 'TESTE RÁPIDO PARA DETECÇÃO DE ANTICORPOS ANTI-HIV EM GESTANTE',
    codigo: '0214010279',
    id_grupo: 'HIV',
  },
  { nm: null, nome: 'MAMOGRAFIA', codigo: '0204030030', id_grupo: 'MAMA' },
  {
    nm: null,
    nome: 'MAMOGRAFIA BILATERAL PARA RASTREAMENTO',
    codigo: '0204030188',
    id_grupo: 'MAMA',
  },
  {
    nm: null,
    nome: 'AFERIÇÃO DE PRESSÃO ARTERIAL',
    codigo: '0301100039',
    id_grupo: 'PA',
  },
  {
    nm: null,
    nome: 'CONSULTA PUERPERAL',
    codigo: '0301010129',
    id_grupo: 'PARTO',
  },
  { nm: null, nome: 'MEDIÇÃO DE PESO', codigo: '0101040083', id_grupo: 'PESO' },
  {
    nm: null,
    nome: 'TESTE TREPONEMICO P/ DETECÇÃO DE SIFILIS',
    codigo: '0202031098',
    id_grupo: 'SIFILIS',
  },
  {
    nm: null,
    nome: 'TESTE NÃO TREPONEMICO P/ DETECÇÃO DE SIFILIS PARA POPULAÇÃO GERAL (EXCETO GESTANTE, PARCEIRO OU PARCERIA)',
    codigo: '0202031110',
    id_grupo: 'SIFILIS',
  },
  {
    nm: null,
    nome: 'TESTE NÃO TREPONEMICO P/ DETECÇÃO DE SIFILIS EM GESTANTES',
    codigo: '0202031179',
    id_grupo: 'SIFILIS',
  },
  {
    nm: null,
    nome: 'TESTE RÁPIDO TREPONÊMICO (SÍFILIS) PARA POPULAÇÃO GERAL(EXCETO GESTANTE, PARCEIRO OU PARCERIA)',
    codigo: '0214010074',
    id_grupo: 'SIFILIS',
  },
  {
    nm: null,
    nome: 'TESTE RÁPIDO PARA SÍFILIS NA GESTANTE OU PAI/PARCEIRO',
    codigo: '0214010082',
    id_grupo: 'SIFILIS',
  },
  {
    nm: null,
    nome: 'TESTE RÁPIDO TREPONÊMICO (SÍFILIS) EM GESTANTE',
    codigo: '0214010252',
    id_grupo: 'SIFILIS',
  },
  {
    nm: null,
    nome: 'COLETA DE MATERIAL DO COLO DE ÚTERO PARA EXAME CITOPATOLÓGICO',
    codigo: '0201020033',
    id_grupo: 'UTERO',
  },
  {
    nm: null,
    nome: 'COLETA DE MATERIAL DO COLO DO ÚTERO PARA EXAME MOLECULAR DE DETECÇÂO DE HPV',
    codigo: '0201020076',
    id_grupo: 'UTERO',
  },
  {
    nm: null,
    nome: 'ENTREGA DE MATERIAL OBTIDO POR AUTO COLETA PARA EXAME MOLECULAR PARA DETECÇÃO DE HPV, NO COLO DO ÚTERO.',
    codigo: '0201020084',
    id_grupo: 'UTERO',
  },
  {
    nm: null,
    nome: 'EXAME CITOPATOLÓGICO CERVICO-VAGINAL/MICROFLORA',
    codigo: '0203010019',
    id_grupo: 'UTERO',
  },
  {
    nm: null,
    nome: 'EXAME CITOPATOLÓGICO CERVICO VAGINAL/MICROFLORA-RASTREAMENTO',
    codigo: '0203010086',
    id_grupo: 'UTERO',
  },
]

export default rawSigtap
